var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.mode == "edit"
      ? _c(
          "div",
          { staticClass: "flex-row" },
          [
            _c("el-input", {
              ref: _vm.reference,
              attrs: {
                placeholder: _vm.prop.defaultValue,
                min: parseInt(_vm.prop.min),
                max: parseInt(_vm.prop.max),
                controls: false
              },
              on: { blur: _vm.handleBlur },
              model: {
                value: _vm.localValue.decimalValue,
                callback: function($$v) {
                  _vm.$set(_vm.localValue, "decimalValue", $$v)
                },
                expression: "localValue.decimalValue"
              }
            }),
            _vm._v(" "),
            _c(
              "el-select",
              {
                staticClass: "ml-2",
                model: {
                  value: _vm.localValue.numericValue,
                  callback: function($$v) {
                    _vm.$set(_vm.localValue, "numericValue", $$v)
                  },
                  expression: "localValue.numericValue"
                }
              },
              _vm._l(_vm.formattedUnits, function(allowedValue, index) {
                return _c("el-option", {
                  key: index,
                  attrs: {
                    label: allowedValue.name,
                    value: parseInt(allowedValue.id)
                  }
                })
              }),
              1
            )
          ],
          1
        )
      : _c("p", [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$filters.numberFormatWithOptions(
                  _vm.value.decimalValue,
                  _vm.unitNumberFormat,
                  false
                )
              ) +
              "\n        " +
              _vm._s(_vm.unit) +
              "\n    "
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }